<template>
  <circle cx="4" cy="4" r="4" />
</template>
